import { Store, configureStore } from "@reduxjs/toolkit";
import React, { useMemo } from "react";
import { Provider } from "react-redux";

import { reverse } from "@reactivated";

import {
    IProductID,
    IWebPageURL,
    isoWebPageURL,
} from "../../../models/nominals";
import { usePageURL } from "../../../utils/urls";
import { Configurator } from "../../configurator/containers/Configurator";
import { getDefaultConfiguratorOptionSet } from "../../configurator/utils";
import { middleware } from "../../middleware";
import { coreReducers } from "../../reducers";
import { IRootState } from "../../reducers.interfaces";

interface IMicroConfiguratorProps {
    rootProductIDs: ReadonlyArray<IProductID>;
    basketLink?: IWebPageURL;
    financingLink?: IWebPageURL;
}

// NOTE: This is a temporary solution to the MicroConfigurator functionality,
//       written by @cweber and @zlebar

export const MicroConfiguratorRowContent = (
    props: IMicroConfiguratorProps,
): React.ReactNode => {
    const financeLink = usePageURL("finance_link");
    const homeLink = usePageURL("home");

    // Required: Redux store must be stable to prevent state resets and infinite loops
    const microStore = useMemo<Store<IRootState>>(() => {
        return configureStore({
            reducer: coreReducers,
            middleware: (getDefaultMiddleware) => {
                return getDefaultMiddleware().concat(middleware);
            },
            devTools: {
                name: `MicroConfigurator-${props.rootProductIDs}`,
            },
        });
    }, [props.rootProductIDs]);

    return (
        <Provider store={microStore}>
            <Configurator
                optionSet={{
                    ...getDefaultConfiguratorOptionSet(),
                    product_ids: props.rootProductIDs,
                }}
                enableHistoryInteraction={false}
                financingLink={props.financingLink || financeLink || homeLink}
                basketLink={
                    props.basketLink ||
                    isoWebPageURL.wrap(reverse("basket:summary"))
                }
                favoritesLink={isoWebPageURL.wrap(reverse("basket:summary"))}
                configureGiftsLink={isoWebPageURL.wrap(
                    reverse("basket:configure-gifts"),
                )}
                configType={"micro"}
                buttonColor={"primary-congress-blue"}
                showShippingLead={false}
                showFeelScale={true}
                showPreTitle={false}
                showVariantCallout={false}
                strikeThroughMSRP={false}
                actualPriceStyle={""}
                boxHeaderContent={""}
                topBadgeContent={""}
                showFinancingModal={true}
            />
        </Provider>
    );
};
